import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import {
  BusinessInfo,
  SimpayxCharge,
  SimpayxItem,
  SimpayxOrder,
  SimpayxVariant,
} from '../models/simpayx-order.model';
import { Item } from '../models/catalogue.model';
// import * as firebase from 'firebase/compat/app';
import { StorageService } from './storage.service';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';
import { BusinessService } from './business.service';
import { UtilityService } from './utility.service';
import { OrderNumberService } from './order-number.service';
import * as firebase from 'firebase/firestore';
import { BusinessInput } from '../models/businessInput.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { Shipment, ShipmentValues } from '../models/shipping.model';
import { LocalstorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class SimpayxOrderService {
  private order: BehaviorSubject<SimpayxOrder> =
    new BehaviorSubject<SimpayxOrder>(new SimpayxOrder());
  private orderItem: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  fireStoreOrderSubscription: Subscription;

  constructor(
    private storageService: StorageService,
    private orderNumberService: OrderNumberService,
    private angularFireStore: AngularFirestore
  ) {}

  getOrderItemSubscription() {
    return this.orderItem.asObservable();
  }

  getOrderSubscription() {
    return this.order.asObservable();
  }

  getOrder(): SimpayxOrder {
    console.log('Order obj', this.order.value);
    return this.order.value;
  }

  fetchOrder() {
    this.stopListeningToFirestore();
    if (this.storageService.getLocalStorageData(LOCAL_STORAGE.ORDERID) !== null) {
        this.fireStoreOrderSubscription = this.angularFireStore
            .collection(environment.ORDER_COLLECTION)
            .doc(this.storageService.getLocalStorageData(LOCAL_STORAGE.ORDERID))
            .valueChanges()
            .subscribe((data: SimpayxOrder) => {
                console.log("Fetch data", data);
                if (data) this.setOrder(data);
            });
    }
}

stopListeningToFirestore() {
  if (this.fireStoreOrderSubscription) {
      this.fireStoreOrderSubscription.unsubscribe();
  }
}

  persistOrderInFirestore(currentOrder: SimpayxOrder) {
    console.log('persist', currentOrder);

    return this.angularFireStore
      .collection(environment.ORDER_COLLECTION)
      .doc(currentOrder.id)
      .ref.set(JSON.parse(JSON.stringify(currentOrder)), {
        merge: true,
      });
  }

  createOrderItemFromCatalogueItem(catalogueItem: Item) {
    var taxes: SimpayxCharge[] = [];
    console.log(catalogueItem);
    catalogueItem.taxes!.forEach((tax) => {
      taxes.push(new SimpayxCharge(tax.name, tax.rate));
    });

    let variant = new SimpayxVariant('', '', 0);

    let orderItem = new SimpayxItem(
      catalogueItem.id,
      '',
      catalogueItem.name,
      catalogueItem.description,
      catalogueItem.price,
      catalogueItem.price,
      catalogueItem.additionalAttributes,
      1,
      '',
      [],
      variant,
      [],
      '',
      firebase.Timestamp.now(),
      taxes
    );

    this.addItem(orderItem);

    //update order item map
    this.incrementOrderItemsMap(orderItem.id);
  }

  addItem(item: SimpayxItem) {
    if (this.order !== undefined && this.order.value.orderNumber?.length > 0) {
      this.updateOrder(item);
      return this.isLoading.asObservable();
    } else {
      this.createOrder(item);
      return this.isLoading.asObservable();
    }
  }

  //Cretes order
  private createOrder(item: SimpayxItem) {
    console.log('order status=', this.order.value);
    let currentOrder = this.order.value;
    let orderItems = this.mergeAddOnIfExist(item);

    orderItems = JSON.parse(JSON.stringify(orderItems));

    currentOrder.currency = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.CURRENCY
    );
    let business: BusinessInput = JSON.parse(
      this.storageService.getLocalStorageData(LOCAL_STORAGE.BUSINESS_DETAILS)
    );
    console.log('business', business);
    let businessInfo = new BusinessInfo(
      business.name,
      this.storageService.getLocalStorageData(
        LOCAL_STORAGE.BUSINESS_VALUES
      ).businessId,
      this.storageService.getLocalStorageData(LOCAL_STORAGE.VERTICAL)
    );
    currentOrder.items.push(...orderItems);
    this.orderNumberService.getNumber().then((orderNumber) => {
      currentOrder.orderNumber = 'PU-' + orderNumber;

      console.log('businessInfo', businessInfo);
      currentOrder.startedAt = currentOrder.updatedAt =
        firebase.Timestamp.now();
      currentOrder.businessInfo = businessInfo;
      currentOrder.merchantId = this.storageService.getLocalStorageData(
        LOCAL_STORAGE.BUSINESS_VALUES
      ).merchantId;
      currentOrder.orderNumber = currentOrder.orderNumber;
      currentOrder.id = UtilityService.generateOrderId();
      this.setOrder(currentOrder);
      this.storageService.setLocalStorageData(
        LOCAL_STORAGE.ORDERID,
        currentOrder.id
      );
      // UtilityService.setOrderId(currentOrder.id);
    });
    console.log('busines detail', currentOrder.userId);
  }

  private updateOrder(item: SimpayxItem) {
    let currentOrder: SimpayxOrder = this.order.value;
    let orderItems = this.mergeAddOnIfExist(item);
    orderItems = JSON.parse(JSON.stringify(orderItems));
    currentOrder.items.push(...orderItems);
    this.setOrder(currentOrder);
    console.log(currentOrder);
  }

  //Updates specific values in order obj
  updateSpecificOrderFields(orderId: string, value: any) {
    this.angularFireStore
      .collection(environment.ORDER_COLLECTION)
      .doc(orderId)
      .update(value);
  }

  setOrder(currentOrder: SimpayxOrder) {
    this.order.next(currentOrder);
    console.log('Set Order', this.order);
    this.isLoading.next(false);
  }

  //Check its use and remove
  private mergeAddOnIfExist(orderItem: SimpayxItem): SimpayxItem[] {
    let items: SimpayxItem[] = [];

    if (orderItem.addOns && orderItem.addOns.length > 0) {
      for (let addon of orderItem.addOns) {
        addon.addOns = [];
        items.unshift(Object.assign({}, addon));
      }
    }

    orderItem.addOns = [];
    items.unshift(Object.assign({}, orderItem));
    return items;
  }

  incrementOrderItemQuantity(itemId: string, orderItem?: SimpayxItem) {
    console.log(itemId, orderItem);

    let currentOrder: SimpayxOrder = this.order.value;

    if (!orderItem) {
      orderItem = currentOrder.items.find((item) => item.id === itemId);
    } else {
      orderItem = currentOrder.items.find(
        (item) =>
          item.id === orderItem!.id &&
          item.name === orderItem!.name &&
          item.variant?.name === orderItem!.variant?.name &&
          item?.customizations[0]?.options?.length ===
            orderItem?.customizations[0]?.options?.length &&
          item?.customizations[0]?.options[0]?.name ===
            orderItem?.customizations[0]?.options[0]?.name
      );
    }
    if (orderItem!.quantity < 15) {
      orderItem!.quantity++;

      this.setOrder(currentOrder);

      //update order item map
      this.incrementOrderItemsMap(itemId);
    }
  }

  //Decreases item quantity in order
  decrementOrderItemQuantity(itemId: string, orderItem?: SimpayxItem) {
    //update order item map
    this.decrementOrderItemsMap(itemId);

    let currentOrder: SimpayxOrder = this.order.value;

    let orderItemIndex = -1;

    if (!orderItem) {
      orderItemIndex = currentOrder.items.findIndex(
        (item) => item.id === itemId
      );
    } else {
      orderItemIndex = currentOrder.items.findIndex(
        (item) =>
          item.id === orderItem.id &&
          item.name === orderItem.name &&
          item.variant?.name === orderItem.variant?.name &&
          item?.customizations[0]?.options?.length ===
            orderItem?.customizations[0]?.options?.length &&
          item?.customizations[0]?.options[0]?.name ===
            orderItem?.customizations[0]?.options[0]?.name
      );
    }

    if (orderItemIndex !== -1) {
      if (currentOrder.items[orderItemIndex].quantity == 1) {
        currentOrder.items.splice(orderItemIndex, 1);
      } else {
        currentOrder.items[orderItemIndex].quantity--;
      }
    }
    this.setOrder(currentOrder);
  }

  private incrementOrderItemsMap(itemId: string) {
    let orderItemMap = this.getOrderItem();
    orderItemMap[itemId] = orderItemMap[itemId] ? orderItemMap[itemId] + 1 : 1;
    this.setOrderItem(orderItemMap);
  }

  private decrementOrderItemsMap(itemId: string) {
    let orderItemMap = this.getOrderItem();
    orderItemMap[itemId] = orderItemMap[itemId] ? orderItemMap[itemId] - 1 : 0;
    this.setOrderItem(orderItemMap);
  }

  getOrderItem() {
    return this.orderItem.value;
  }

  setOrderItem(orderItem: any) {
    this.orderItem.next(orderItem);
  }

  addShipmentDetails(shipment: Shipment) {
    let currentOrder: SimpayxOrder = this.order.value;
    currentOrder.shipment = shipment;
    this.setOrder(currentOrder);
  }

  addShipmentValues(shipmentValues: ShipmentValues) {
    let currentOrder: SimpayxOrder = this.order.value;
    currentOrder.shipmentValues = shipmentValues;
    this.setOrder(currentOrder);
  }
}
